<mat-form-field mat-select-height-large data-at-language-picker>
  <mat-label>{{ '+SETTINGS.LANGUAGE.LABEL' | translate }}</mat-label>
  <mat-select [(ngModel)]="value" (selectionChange)="changeValue()" fieldTextContentTooltip>
    <mat-select-trigger>
      <span *ngIf="value" class="flag {{ getCountryFlag(value) }}"></span>
      {{ getLanguageValue(value) | translate }}
    </mat-select-trigger>
    <mat-option
      *ngFor="let key of keys"
      value="{{ languageCodes[key] }}"
      gtm="onSelect"
      gtmAction="Language"
      gtmCategory="settings"
      fieldTextContentTooltip
    >
      <span class="flag {{ getCountryFlag(key) }}"></span>

      {{ languageValues[languageCodes[key]] | translate }}
    </mat-option>
  </mat-select>
</mat-form-field>
